module.exports = {"id":"s6-q1a","text":"Do you manage the apps and software on your computer yourself?","multiselect":false,"next":"s6-q1b","options":[{"id":"s6-q1a-a1","text":"Yes","capability":3,"access":0,"focusarea":[0,0,0,6,4]},{"id":"s6-q1a-a2","text":"No","capability":-1,"access":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s6-q1a.json
// module id = 927
// module chunks = 32